var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"variant":"primary","block":""}},[_vm._v(" "+_vm._s(_vm.element.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }